const CMS_IMAGE_PREFIX = '/cms/images';
const CMS_IMAGE_PREFIX_REGEX = /^\/?cms\/images/;

const CMS_AVAILABLE_WIDTHS: number[] = [
  320, 480, 640, 800, 960, 1040, 1120, 1200, 1280, 1440, 1600, 1760, 1920, 2560, 3200, 3840,
];

const getFilteredWidths = (maxWidth: number): number[] => {
  if (!CMS_AVAILABLE_WIDTHS.length) {
    return [];
  }

  if (maxWidth < CMS_AVAILABLE_WIDTHS[0]) {
    return [CMS_AVAILABLE_WIDTHS[0]];
  }

  const lastWidth = CMS_AVAILABLE_WIDTHS[CMS_AVAILABLE_WIDTHS.length - 1];
  if (maxWidth >= lastWidth) {
    return CMS_AVAILABLE_WIDTHS;
  }

  return CMS_AVAILABLE_WIDTHS.filter((width) => width <= maxWidth);
};

const getBestAvailableWidth = (targetWidth: number, availableWidths: number[]): number | undefined => {
  // eslint-disable-next-line unicorn/no-array-sort -- toSorted() is not available with the es2022 target
  const sortedWidths = [...new Set(availableWidths)].sort((left, right) => left - right);

  if (!sortedWidths.length) {
    return undefined;
  }

  return sortedWidths.find((width) => width >= targetWidth) ?? sortedWidths[sortedWidths.length - 1];
};

const transformToSizedSrc = (src: string, width: number): string | undefined => {
  if (CMS_IMAGE_PREFIX_REGEX.test(src)) {
    return src.replace(CMS_IMAGE_PREFIX_REGEX, `${CMS_IMAGE_PREFIX}/${width}/auto`);
  }

  if (src.includes('{width}')) {
    return src.replace('{width}', width.toString());
  }

  return undefined;
};

export { CMS_AVAILABLE_WIDTHS, getBestAvailableWidth, getFilteredWidths, transformToSizedSrc };
